// All services with grouping for the bento grid
export const ALL_SERVICES = [
  { slug: "web-development", code: "01", title: "Web Development",          short: "React, Next.js & Node platforms.",     group: "Web" },
  { slug: "website-design",  code: "02", title: "Website Design",           short: "UI/UX & conversion-focused design.",   group: "Web" },
  { slug: "custom-software", code: "03", title: "Custom Software",          short: "Bespoke business applications.",       group: "Web" },
  { slug: "api-development", code: "04", title: "API Development",          short: "REST & GraphQL APIs built to scale.",  group: "Web" },

  { slug: "mobile-apps",     code: "05", title: "Mobile Apps",              short: "Cross-platform & native apps.",        group: "Mobile" },
  { slug: "android-apps",    code: "06", title: "Android Apps",             short: "Kotlin & Jetpack Compose.",            group: "Mobile" },
  { slug: "ios-apps",        code: "07", title: "iOS Apps",                 short: "Swift & SwiftUI native experiences.",  group: "Mobile" },

  { slug: "hosting",         code: "08", title: "Website Hosting",          short: "Shared, business & managed plans.",    group: "Hosting" },
  { slug: "vps-hosting",     code: "09", title: "VPS Hosting",              short: "Root access, NVMe, scalable.",         group: "Hosting" },
  { slug: "cloud-hosting",   code: "10", title: "Cloud Hosting",            short: "AWS, GCP & Azure deployments.",        group: "Hosting" },
  { slug: "managed-servers", code: "11", title: "Managed Servers",          short: "We handle ops, you ship features.",    group: "Hosting" },
  { slug: "linux-admin",     code: "12", title: "Linux Administration",     short: "Hardening, monitoring, automation.",   group: "Hosting" },
  { slug: "devops",          code: "13", title: "DevOps & CI/CD",           short: "Docker, K8s, GitHub Actions.",         group: "Hosting" },

  { slug: "blockchain",      code: "14", title: "Blockchain & Web3",        short: "Smart contracts, dApps & DeFi.",       group: "Web3" },
  { slug: "smart-contracts", code: "15", title: "Smart Contracts",          short: "Audited Solidity & ERC-standards.",    group: "Web3" },
  { slug: "tokens-nfts",     code: "16", title: "Token & NFT Platforms",    short: "ERC-20/721/1155 launchpads.",          group: "Web3" },
  { slug: "defi",            code: "17", title: "DeFi Solutions",           short: "Staking, AMM, yield protocols.",       group: "Web3" },

  { slug: "seo",             code: "18", title: "SEO Services",             short: "Rank higher, convert better.",         group: "Growth" },
  { slug: "automation",      code: "19", title: "Business Automation",      short: "Workflow + AI document pipelines.",    group: "Growth" },
  { slug: "ai-integration",  code: "20", title: "AI Integration",           short: "LLMs, vector DBs, copilots.",          group: "Growth" },
  { slug: "graphic-design",  code: "21", title: "Graphic Design",           short: "Brand identity & visuals.",            group: "Design" },
  { slug: "templates",       code: "22", title: "Promotional Templates",    short: "Ads, decks, email templates.",         group: "Design" },
  { slug: "it-consulting",   code: "23", title: "IT Consulting",            short: "Architecture & modernization.",        group: "Strategy" },
];

// Detail pages for the 5 deep pages
export const SERVICE_DETAILS = {
  "web-development": {
    title: "Web Development",
    tagline: "High-performance web platforms that scale.",
    hero: "From marketing sites to mission-critical SaaS platforms — we engineer modern web applications using React, Next.js and Node that load fast, rank high and convert visitors into customers.",
    image: "https://images.unsplash.com/photo-1551033406-611cf9a28f67?w=1200&q=80",
    offerings: [
      { t: "Marketing & Landing Sites",   d: "SEO-first, lightning-fast Next.js sites with CMS integrations." },
      { t: "SaaS Web Applications",        d: "Multi-tenant dashboards, billing, RBAC and analytics built in." },
      { t: "Headless E-commerce",          d: "Storefronts on Shopify, Medusa or custom — connected to any backend." },
      { t: "Internal Tools & Dashboards",  d: "Replace fragile spreadsheets with secure custom admin panels." },
      { t: "Progressive Web Apps",         d: "Installable, offline-capable web experiences for any device." },
      { t: "API & Backend Engineering",    d: "Node, Python and Go services — REST, GraphQL, websockets." },
    ],
    stack: ["React", "Next.js", "TypeScript", "Node.js", "Tailwind CSS", "PostgreSQL", "Prisma", "Vercel"],
    process: [
      { t: "Architecture",  d: "Schema, data flow, security model — designed before code." },
      { t: "Design system", d: "Tokens, components, accessibility baked into the codebase." },
      { t: "Sprint build",  d: "Weekly demos, source-on-day-one, full ownership." },
      { t: "Launch & SLA",  d: "Zero-downtime deploy, monitoring, post-launch maintenance." },
    ],
    metrics: [
      { v: "98+",  l: "Lighthouse avg" },
      { v: "<1.2s", l: "First Contentful Paint" },
      { v: "99.99%", l: "Production uptime" },
    ],
  },

  "mobile-apps": {
    title: "Mobile App Development",
    tagline: "Native iOS, Android & cross-platform apps.",
    hero: "We design and build mobile experiences your users open every day — from offline-first React Native apps to fully native Swift & Kotlin builds with App Store and Play Store delivery handled end-to-end.",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=1200&q=80",
    offerings: [
      { t: "iOS — Swift & SwiftUI",        d: "Native iPhone, iPad and watchOS apps with deep iOS integrations." },
      { t: "Android — Kotlin & Compose",   d: "Material You design, modular architecture, Google Play optimized." },
      { t: "React Native Cross-platform",  d: "Single codebase, native look-and-feel, fast time-to-market." },
      { t: "Offline-First Sync",            d: "Realm/WatermelonDB pipelines for unreliable network environments." },
      { t: "Push, Analytics & Crash",      d: "Firebase, Amplitude, Sentry wired in from day one." },
      { t: "Store Submission & ASO",       d: "App Store / Play Store listing, screenshots, keywords, reviews." },
    ],
    stack: ["React Native", "Swift", "Kotlin", "Expo", "Firebase", "GraphQL", "Realm", "Fastlane"],
    process: [
      { t: "User flows",  d: "We map every screen and interaction before opening Xcode." },
      { t: "Prototyping", d: "Figma + clickable prototypes reviewed on real devices." },
      { t: "Build",       d: "TestFlight & Play Console beta releases every Friday." },
      { t: "Launch",      d: "Store submission, ASO and post-launch crash monitoring." },
    ],
    metrics: [
      { v: "4.7+", l: "Avg store rating" },
      { v: "<0.3%", l: "Crash-free rate" },
      { v: "30%", l: "Faster TTM vs native" },
    ],
  },

  "blockchain": {
    title: "Blockchain & Web3 Development",
    tagline: "Smart contracts, DeFi & NFT platforms — audited.",
    hero: "We build serious on-chain products — from audited Solidity smart contracts and DeFi protocols to NFT launchpads, wallet integrations and full Web3 frontends. Every contract is tested, gas-optimized and reviewed.",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=1200&q=80",
    offerings: [
      { t: "Smart Contract Development",   d: "ERC-20, 721, 1155 and custom logic with full test coverage." },
      { t: "Token Launchpads",             d: "Launch utility tokens with vesting, locks and KYC if needed." },
      { t: "NFT Platforms",                d: "Marketplaces, mints, royalties, OpenSea-compatible metadata." },
      { t: "DeFi Protocols",                d: "Staking, AMM, lending, yield farming — built to spec." },
      { t: "Wallet Integration",           d: "WalletConnect, MetaMask, Coinbase Wallet, in-app wallets." },
      { t: "Audits & Gas Optimization",    d: "Slither, Mythril, manual review and gas profiling." },
    ],
    stack: ["Solidity", "Hardhat", "Foundry", "Ethers.js", "Wagmi", "The Graph", "IPFS", "OpenZeppelin"],
    process: [
      { t: "Threat modeling", d: "We start with what could go wrong — before writing a single line." },
      { t: "Test-first",      d: "100% test coverage, fuzz testing, mainnet forking." },
      { t: "Audit",           d: "Internal + recommended external review before mainnet." },
      { t: "Deploy & monitor", d: "Multisig deploys, OpenZeppelin Defender monitoring." },
    ],
    metrics: [
      { v: "$32M+", l: "TVL secured" },
      { v: "100%", l: "Test coverage" },
      { v: "0", l: "Critical incidents" },
    ],
  },

  "seo": {
    title: "SEO & Growth Services",
    tagline: "Rank higher. Convert better. Compound forever.",
    hero: "Technical SEO + content programs + conversion experiments — we treat search like engineering, not marketing. Quarterly roadmaps, transparent reporting, no fluff metrics.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80",
    offerings: [
      { t: "Technical SEO Audits",        d: "Crawl, indexing, schema, Core Web Vitals — full report + fixes." },
      { t: "On-Page Optimization",         d: "Title, meta, internal linking, content gaps — applied site-wide." },
      { t: "Content Programs",             d: "SEO-led editorial calendar, briefs, drafting and publishing." },
      { t: "Link Building",                d: "White-hat outreach and digital PR — no PBNs, ever." },
      { t: "Conversion Experiments",      d: "Hypotheses, A/B tests and funnel improvements." },
      { t: "Analytics & Reporting",        d: "GA4, GSC, Looker Studio — KPIs you actually care about." },
    ],
    stack: ["Ahrefs", "Semrush", "GSC", "GA4", "Screaming Frog", "Looker Studio", "Clearscope", "Hotjar"],
    process: [
      { t: "Audit",      d: "30-point technical + content audit delivered in week one." },
      { t: "Roadmap",    d: "90-day prioritized plan with effort vs impact scored." },
      { t: "Execute",    d: "Monthly sprints — we implement, you approve." },
      { t: "Report",     d: "Live dashboard + monthly call reviewing what moved." },
    ],
    metrics: [
      { v: "3.4×", l: "Avg organic traffic lift" },
      { v: "90d",  l: "First-results timeline" },
      { v: "100%", l: "Transparent reporting" },
    ],
  },
};
